<div>
  <div class="row">
    <div class="col-md-8">
      <div
        class="card"
        [ngStyle]="{ 'border-top': inspection?.status == InspectionStatus.REJECTED ? '4px solid red' : '' }">
        <div class="card-body">
          <div class="row" *ngIf="items?.length">
            <div class="col-lg-3">
              <h4>Item</h4>

              <ul class="list-group">
                <li
                  class="list-group-item"
                  *ngFor="let item of items; index as i"
                  [ngStyle]="{ 'background-color': selectedItemIndex === i ? '#eee' : '#fff' }"
                  (click)="selectedItemIndex = i">
                  <div class="row">
                    <div class="col-lg-12">
                      <p>{{ item.label }}</p>
                      <div class="progress progress-xs" style="background-color: #dc3e3e">
                        <div
                          class="progress-bar bg-success"
                          role="progressbar"
                          [ngStyle]="{ width: item.progress + '%' }"></div>
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
            <div class="col-lg-3">
              <h4>Section</h4>

              <ul class="list-group">
                <li
                  class="list-group-item"
                  *ngFor="let item of sections; index as i"
                  [ngStyle]="{ 'background-color': selectedSectionIndex === i ? '#eee' : '#fff' }"
                  (click)="selectedSectionIndex = i">
                  <div class="row">
                    <div class="col-lg-12">
                      <p>{{ item.name }}</p>
                      <div class="progress progress-xs" style="background-color: #dc3e3e">
                        <div
                          class="progress-bar bg-success"
                          role="progressbar"
                          [ngStyle]="{ width: item.progress + '%' }"></div>
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
            <div class="col-lg-4">
              <h4>Question</h4>

              <ul class="list-group">
                <ng-container *ngFor="let item of questions; index as i">
                  <li class="list-group-item" *ngIf="item.show">
                    <div class="row">
                      <div class="col-lg-3">
                        <i class="fa {{ questionIcon(item) }}" style="font-size: 30px; color: #aaa"></i>
                      </div>
                      <div class="col-lg-8">
                        {{ item.text }}
                        <div *ngIf="questionNComments(item)" style="margin-top: 10px">
                          <span *ngIf="questionNComments(item)">
                            <i class="fa fa-comment" style="color: #2763cd"></i>&nbsp;{{ questionNComments(item) }}
                          </span>
                        </div>
                      </div>
                    </div>
                  </li>
                </ng-container>
              </ul>
            </div>

            <div class="col-lg-2">
              <div style="text-align: center; margin-top: 50px">
                <span style="font-size: 25px; font-weight: bold">{{ pAccepted || 0 }}%</span><br />
                <span style="font-size: 12px">Accepted</span>
                <div class="progress progress-xsss" style="background-color: #dc3e3e">
                  <div class="progress-bar bg-success" role="progressbar" [ngStyle]="{ width: pAccepted + '%' }"></div>
                </div>
              </div>

              <div style="text-align: center; margin-top: 50px">
                <span style="font-size: 25px; font-weight: bold">{{ nComments }}</span
                ><br />
                <span style="font-size: 12px">Comments</span>
              </div>
              <!-- <div style="text-align:center;margin-top:50px">
                                <span style="font-size:25px;font-weight:bold">8.0</span><br />
                                <span style="font-size:12px">Rating</span>
                            </div> -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-4">
      <div class="card" *ngIf="inspection">
        <div class="card-body">
          <h4 style="display: inline-block">Inspection details</h4>
          &nbsp;

          <br />
          <br />

          <p>Address: {{ inspection.address }}, {{ inspection.zip }}, {{ inspection.city }} {{ inspection.state }}</p>

          <p>
            Customer: {{ inspection.customerName }}
            <br />
            Contact: {{ inspection.contactName }}
          </p>

          <p>
            Customer mobile: {{ inspection.contactPhone }}
            <br />
            Customer email: {{ inspection.contactEmail }}
          </p>

          <p>Inspector: {{ inspection.inspector.name }}</p>

          <p>
            Completed: {{ dateAsString(inspection.completed) }}
            <br />
            Last Synced: {{ dateAsString(inspection.lastSynced) }}
          </p>

          <div class="animated fadeIn">
            <div class="animated fadeIn">
              <div class="card">
                <div class="card-header" style="cursor: pointer" (click)="isCommentsCollapsed = !isCommentsCollapsed">
                  Comments ({{ nComments }}) <i class="fa fa-angle-down" style="float: right; font-size: 25px"></i>
                </div>
                <div class="card-body" [collapse]="isCommentsCollapsed">
                  <div class="row">
                    <div class="col-md-12">
                      <div class="card" *ngFor="let a of answersWithComments">
                        <div class="card-body">
                          <h6 style="font-weight: bold; text-align: left">
                            <span *ngIf="a.path?.question?.legacyId">({{ a.path.question.legacyId }})</span>
                            {{ a.path?.question?.text }} <span *ngIf="a.buildingIndex"> #{{ a.buildingIndex }}</span>
                          </h6>
                          <div style="margin-top: 10px">
                            <div *ngFor="let f of a.comments; index as i">
                              <div>
                                {{ f.text }}
                                <!-- <button type="button" class="btn btn-sm btn-danger"
                                                                    style="float:right;margin:2px"
                                                                    (click)="removeComment(a,i)">
                                                                    <i class="fa fa-trash"></i>
                                                                </button> -->
                              </div>
                              <br style="clear: both" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
